import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { Area } from 'api/types/lookups';
import type { IRequestException } from 'api/types/requestException';

interface IGetZipcodeResponse {
    state: Area['state'];
    city: Area['city'];
}

export type IGetZipcodeProps = { code: string };

const getZipcodes = async ({ code }: IGetZipcodeProps) => {
    const response = await apiClient.get('zipcodes', {
        searchParams: { code },
    });

    return (await response.json()) as IGetZipcodeResponse;
};

export const useGetZipcodesMutation = (
    options: UseMutationOptions<
        IGetZipcodeResponse,
        IRequestException,
        IGetZipcodeProps
    >
) => {
    return useMutation<
        IGetZipcodeResponse,
        IRequestException,
        IGetZipcodeProps
    >('zipcodes', async (data) => await getZipcodes(data), options);
};
